import React, { useEffect, useState, useRef } from 'react';
import TableDataLayer from "../components/TableDataLayer";
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import { apiCall } from "../utils/apiService";

const PhonebookLayer = () => {
    const [phonebooks, setPhonebooks] = useState([]);
    const [contacts, setContacts] = useState([]);
    const [tags, setTags] = useState([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedTagId, setSelectedTagId] = useState(null);
    const [alertMessage, setAlertMessage] = useState('');
    const [name, setName] = useState('');
    const [contactType, setContactType] = useState('individual');
    const [contact, setContact] = useState({
        name: "",
        mobile: "",
        phonebookName: "",
        file: "",
    });

    // refs
    const phonebookRef = useRef(null);
    const phonebookDelRef = useRef(null);
    const contactsRef = useRef(null);

    const fetchPhonebooks = async () => {
        try {
            const response = await apiCall({
                url: `phonebook/get-phonebook`,
                method: 'GET',
            });
            setPhonebooks(response.data);
            createTags(response.data)
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const fetchContacts = async () => {
        try {
            const response = await apiCall({
                url: `phonebook/get-contact`,
                method: 'GET',
            });
            setContacts(response.total);
            return response
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    // create new instance
    const handlePhonebookSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        const { isValid, messageText } = validated();
        if (isValid) {
            try {
                const response = await apiCall({
                    url: `phonebook/add-phonebook`,
                    method: 'POST',
                    body: { name }
                });

                // For example, store token in local storage
                const data = response;
                if (data.success) {
                    receiveDataFromAddNewPhonebook({
                        id: data.data.insertId,
                        name,
                    })

                    phonebookRef.current.click();
                    setAlertMessage({ message: data.msg, class: 'success' });
                    cleanForm()
                } else {
                    setAlertMessage({ message: data.msg, class: 'danger' });
                }

            } catch (error) {
                // setError('Something Went Wrong');
                setAlertMessage({ message: error.message, class: 'danger' });
                console.error('Login error:', error); // Log error to console
            }
        } else {
            setAlertMessage({ message: messageText, class: 'danger' });
            hideAlert(2);
        }
    };

    // create new instance
    const handleContactSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission
        const { isValid, messageText } = validatedContact();
        if (isValid) {
            try {

                const response = await apiCall({
                    url: `phonebook/add-contact`,
                    method: 'POST',
                    body: contact
                });

                const data = response;
                if (data.success) {
                    setAlertMessage({ message: data.msg, class: 'success' });
                    contactsRef.current.click()
                    fetchContacts();
                    cleanContactForm()
                } else {
                    setAlertMessage({ message: data.msg, class: 'danger' });
                }

            } catch (error) {
                // setError('Something Went Wrong');
                setAlertMessage({ message: error.message, class: 'danger' });
                console.error('Login error:', error); // Log error to console
            }
        } else {
            setAlertMessage({ message: messageText, class: 'danger' });
            hideAlert(2);
        }
    };

    // handle to upload contact csv
    const handleToImportCSV = async (e) => {
        e.preventDefault(); // Prevent default form submission
        try {

            // Create a FormData object
            const formData = new FormData();

            // Append each field from the media state to the FormData object
            for (let key in contact) {
                formData.append(key, contact[key]);
            }

            const response = await apiCall({
                url: `phonebook/add-csv`,
                method: 'POST',
                body: formData,
                withoutStringify: true
            });

            // Handle successful login
            const data = response;
            setAlertMessage({ message: data.msg, class: 'success' });
            if (data.success) {
                window.location.href = "/phonebooks"
                cleanForm()
            } else {
                setAlertMessage({ message: data.msg, class: 'danger' });
                hideAlert(2);
            }


        } catch (error) {
            setAlertMessage({ message: error.message, class: 'danger' });
            console.error('Login error:', error);
            hideAlert(2);
        }
    };

    // validate form
    const validated = () => {
        if (name == '') {
            return { isValid: false, messageText: 'Name is required!' };
        }
        return { isValid: true, messageText: '' }
    }

    // validate form
    const validatedContact = () => {
        if (contact.name == '') {
            return { isValid: false, messageText: 'Name is required!' };
        } else if (contact.mobile == '') {
            return { isValid: false, messageText: 'Mobile is required!' };
        } else if (contact.phonebookName == '') {
            return { isValid: false, messageText: 'Phonebook is required!' };
        }
        return { isValid: true, messageText: '' }
    }

    // after submission form will be cleared
    const cleanContactForm = () => {
        setContact({
            name: "",
            mobile: "",
            phonebookName: "",
            file: "",
        });
        hideAlert(2);
    }

    // after submission form will be cleared
    const cleanForm = () => {
        setName('');
        hideAlert(2);
    }

    // hide alert after few seconds
    const hideAlert = (sec = 1) => {
        setTimeout(() => {
            setAlertMessage('');
        }, (sec * 1000));
    }

    // handle file with form
    const handleFileChange = (event) => {
        setContact(prevContact => ({
            ...prevContact,
            file: event.target.files[0],
        }))
    };

    const createTags = (data) => {
        data.forEach((tag) => {
            handleAddTag(tag);
        })
    }

    // handle to download the file
    const filePath = '/whatsapp-contact-importer.csv';

    const receiveDataFromAddNewPhonebook = (tag) => {
        setPhonebooks([tag, ...phonebooks])
        handleAddTag(tag);
    }

    const handleAddTag = (tag) => {
        setTags((prevTags) => [
            ...prevTags,
            { id: tag.id, name: tag.name }
        ]);
    };

    const handleRemoveTag = (id) => {
        console.log(id)
        showAlert(id);
    };

    // Display an alert dialog
    const showAlert = (id) => {
        setSelectedTagId(id);
        setModalVisible(true);
    };

    const handleConfirm = () => {
        const tag = tags.find(tag => tag.id === selectedTagId);
        setTags(tags.filter(tag => tag.id !== selectedTagId));
        removePhonebook(tag);
        setModalVisible(false);
    };

    const handleCancel = () => {
        setModalVisible(false);
    };

    const removePhonebook = async (tag) => {
        try {
            const data = await apiCall({
                url: `phonebook/delete-phonebook`,
                method: 'POST',
                body: { id: tag.id, name: tag.name }
            });
            if (data.success) {
                window.location.reload();
                fetchPhonebooks();
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };

    const removeContact = async (ids) => {
        try {
            const data = await apiCall({
                url: `phonebook/delete-contact`,
                method: 'POST',
                body: { selected: ids }
            });
            if (data.success) {
                // window.location.reload();
                fetchContacts();
            }
        } catch (error) {
            console.error('Error fetching dashboard:', error);
        }
    };
    const columns = [
        { key: 'id', label: 'ID' },
        { key: 'name', label: 'Name' },
        { key: 'phonebook_name', label: 'Phonebook' },
        { key: 'mobile', label: 'Mobile' },
        {
            key: 'createdAt',
            label: 'Date&Time',
            render: (val, row) => {
                const date = new Date(val);
                return date.toLocaleString();
            },
        },
        {
            key: 'actions',
            label: 'Actions',
            render: (val, row) => (
                <>
                    <Link
                        onClick={() => removeContact([row.id])}
                        className="w-32-px h-32-px me-8 bg-danger-focus text-danger-main rounded-circle d-inline-flex align-items-center justify-content-center"
                        to="javascript:void(0)"
                    >
                        <Icon icon="mingcute:delete-2-line" />
                    </Link>
                </>

            ),
        },
    ];

    useEffect(() => {
        document.title = 'Contact List'
        fetchPhonebooks();
    }, []);

    const tagStyle = {
        display: 'inline-block',
        backgroundColor: '#f0f0f0',
        color: '#333',
        borderRadius: '3px',
        padding: '5px 10px',
        marginRight: '5px',
        marginBottom: '5px',
    };

    const buttonStyle = {
        background: 'none',
        border: 'none',
        color: 'red',
        fontSize: '20px',
        marginLeft: '5px',
        cursor: 'pointer',
    };

    return (
        <>
            <p><strong>Phonebook List</strong></p>
            <div className='p-3 border rounded'>
                {tags.map((tag, index) => (
                    <div key={index} style={tagStyle} className="tag">
                        <span>{tag.name}</span>
                        <button data-bs-toggle="modal"
                            data-bs-target="#phonebookModalDel" style={buttonStyle} onClick={() => handleRemoveTag(tag.id)}>&times;</button>
                    </div>
                ))}


                {/* Modal delete phonebook */}
                <div
                    className="modal fade"
                    id="phonebookModalDel"
                    tabIndex={-1}
                    aria-labelledby="phonebookModalDelLabel"
                    aria-hidden="true"
                >
                    <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                        <div className="modal-content radius-16 bg-base">
                            <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                                <h1 className="modal-title fs-5" id="phonebookModalDelLabel">
                                    Delete Records
                                </h1>
                                <button
                                    type="button"
                                    id="close-btn"
                                    className="btn-close"
                                    data-bs-dismiss="modal"
                                    aria-label="Close"
                                    ref={phonebookDelRef}
                                />
                            </div>
                            <div className="modal-body p-24">
                                <p>It will delete all the contacts under this phonebook. Are you sure?</p>
                                <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                    <button
                                        onClick={handleConfirm}
                                        type="button"
                                        className="border border-success-600 bg-hover-success-200 text-success-600 text-md px-40 py-11 radius-8"
                                    >
                                        Yes
                                    </button>
                                    <button
                                        onClick={handleCancel}
                                        type="button"
                                        className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                    >
                                        Cancel
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 my-3">
                <button className="btn btn-success" data-bs-toggle="modal"
                    data-bs-target="#phonebookModal"><Icon
                        icon="ic:baseline-plus"
                        className="icon text-xl line-height-1"
                    />Add Phonebook</button>
                <button data-bs-toggle="modal"
                    data-bs-target="#contactModal" className="btn btn-success"><Icon
                        icon="ic:baseline-plus"
                        className="icon text-xl line-height-1"
                    /> Add New Contact</button>
            </div>

            {/* TableDataLayer */}
            <div className="card basic-data-table">
                <div className="card-header">
                    <div className="d-flex justify-content-between alig-items-center">
                        <h5 className="card-title mb-0">Contact List</h5>
                    </div>
                </div>
                <TableDataLayer
                    columns={columns}
                    totalRows={contacts}
                    fetchData={fetchContacts}
                />
            </div>

            {/* Modal Add phonebook */}
            <div
                className="modal fade"
                id="phonebookModal"
                tabIndex={-1}
                aria-labelledby="phonebookModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="phonebookModalLabel">
                                Add New Phonebook
                            </h1>
                            <button
                                type="button"
                                id="close-btn"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                ref={phonebookRef}
                            />
                        </div>
                        <div className="modal-body p-24">
                            {
                                alertMessage && (
                                    <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                                        {alertMessage.message}
                                    </div>
                                )
                            }
                            <form onSubmit={handlePhonebookSubmit}>
                                <div className="row">
                                    <div className="col-12 mb-20">
                                        <input
                                            type="text"
                                            className="form-control radius-8"
                                            id="name"
                                            placeholder="Phonebook Name"
                                            onChange={(e) => setName(e.target.value)}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                        <button
                                            type="reset"
                                            className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                        >
                                            Reset
                                        </button>
                                        <button
                                            type="submit"
                                            className="btn btn-success border border-success-600 text-md px-24 py-12 radius-8"
                                        >
                                            Save Change
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

            {/* Modal Add contact */}
            <div
                className="modal fade"
                id="contactModal"
                tabIndex={-1}
                aria-labelledby="contactModalLabel"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-lg modal-dialog modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border border-top-0 border-start-0 border-end-0">
                            <h1 className="modal-title fs-5" id="contactModalLabel">
                                Add New Contact
                            </h1>
                            <button
                                type="button"
                                id="close-btn"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                ref={contactsRef}
                            />
                        </div>
                        <div className="modal-body p-24">
                            <div className='d-flex gap-3 mb-20'>
                                <button onClick={() => setContactType('individual')} className={contactType == 'individual' ? 'border-bottom text-success-main' : ''}>Add Individual</button>
                                <button onClick={() => setContactType('importcsv')} className={contactType == 'importcsv' ? 'border-bottom text-success-main' : ''}>Import as CSV</button>
                            </div>
                            <hr className='mb-20' />
                            {
                                alertMessage && (
                                    <div className={`alert alert-${alertMessage.class}`} style={{ fontSize: '12px' }}>
                                        {alertMessage.message}
                                    </div>
                                )
                            }
                            {
                                contactType == 'individual' && (
                                    <form onSubmit={handleContactSubmit}>
                                        <div className="row">
                                            <div className="col-12 mb-20">
                                                <input
                                                    type="text"
                                                    className="form-control radius-8"
                                                    id="name"
                                                    placeholder="Contact Name"
                                                    value={contact.name}
                                                    onChange={(e) => setContact({ ...contact, name: e.target.value })}
                                                />
                                            </div>
                                            <div className="col-12 mb-20">
                                                <input
                                                    type="number"
                                                    className="form-control"
                                                    placeholder="Set Contact Number"
                                                    value={contact.mobile}
                                                    onChange={(e) => setContact({ ...contact, mobile: e.target.value })}
                                                />
                                            </div>
                                            <div className='col-12 mb-20'>
                                                <select className="form-select" value={contact.phonebookName} onChange={(e) => setContact({ ...contact, phonebookName: e.target.value })}>
                                                    <option>Select Phonebook</option>
                                                    {phonebooks.map((phonebook) => (
                                                        <option key={phonebook._id} value={phonebook.name}>
                                                            {phonebook.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                                <button
                                                    type="reset"
                                                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                                >
                                                    Reset
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success border border-success-600 text-md px-24 py-12 radius-8"
                                                >
                                                    Save Change
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )
                            }
                            {
                                contactType == 'importcsv' && (
                                    <form onSubmit={handleToImportCSV}>
                                        <div className="mb-3">
                                            <a href={filePath} className="btn btn-success w-100" download>Download File as Sample</a>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 mb-20">
                                                <label htmlFor="">Select CSV</label>
                                                <input
                                                    type="file"
                                                    className="form-control"
                                                    placeholder="Select csv file"
                                                    onChange={handleFileChange}
                                                />
                                            </div>
                                            <div className='col-12 mb-20'>
                                                <select className="form-select" value={contact.phonebookName} onChange={(e) => setContact({ ...contact, phonebookName: e.target.value })}>
                                                    <option>Select Phonebook</option>
                                                    {phonebooks.map((phonebook) => (
                                                        <option key={phonebook._id} value={phonebook.name}>
                                                            {phonebook.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center gap-3 mt-24">
                                                <button
                                                    type="reset"
                                                    className="border border-danger-600 bg-hover-danger-200 text-danger-600 text-md px-40 py-11 radius-8"
                                                >
                                                    Reset
                                                </button>
                                                <button
                                                    type="submit"
                                                    className="btn btn-success border border-success-600 text-md px-24 py-12 radius-8"
                                                >
                                                    Save Change
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                )
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default PhonebookLayer